import { makeSx } from '../../../../theme/_utils'

export default makeSx({
    formSection: {
        width: '100%',
    },
    formSectionInner: {
        width: '100%',
    },
    formSectionLabel: {
        fontWeight: 700,
        fontSize: '1.125rem',
    },
})
